module.exports = __webpack_public_path__ + "img/block_2.1f1f80f6.webp";